import { BrowserDataCacheSubscribable } from './types';

export class BrowserDataCacheSubject<T> implements BrowserDataCacheSubscribable<T> {
  private listeners = new Set<(value: T) => void>();

  subscribe(listener: (value: T) => void): { unsubscribe(): void } {
    this.listeners.add(listener);
    return {
      unsubscribe: () => this.listeners.delete(listener),
    };
  }

  next(value: T): void {
    for (const listener of Array.from(this.listeners)) {
      listener(value);
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
